import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "\n          お仕事の募集が開始された際のプッシュ通知の受信設定を変更できます\n        ", -1)

import { computed, ref } from "vue";
import { useRouter } from "vue-router";
import { accountService } from "@/app/services/AccountService";
import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import InfoCard from "@/components/atoms/other/InfoCard.vue";
import FormRadioGroup from "@/components/molecules/form/FormRadioGroup.vue";
import Header from "@/components/organisms/common/Header.vue";
import { authStore } from "@/store/auth";
import { useLoader } from "@/utils/loader";
import { useErrorModal, useModal } from "@/utils/modal";
import { useCustomRouter } from "@/utils/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReceivePushNotification',
  setup(__props) {

const loader = useLoader();
const errorModal = useErrorModal();
const modal = useModal();
const router = useRouter();
const customRouter = useCustomRouter();

const isReceivedFavoriteOfficeOrder = ref(
  authStore.user?.isReceivedFavoriteOfficeOrder
);
const isReceivedLimitedOrder = ref(authStore.user?.isReceivedLimitedOrder);
const isReceivedIndividualOrder = ref(
  authStore.user?.isReceivedIndividualOrder
);
const isReceivedNearbyOfficeOrder = ref(
  authStore.user?.isReceivedNearbyOfficeOrder
);
const isReceivedCancelRecoveryOrderPushForWorker = ref(
  authStore.user?.isReceivedCancelRecoveryOrderPushForWorker
);

const options = [
  { text: "はい", value: true },
  { text: "いいえ", value: false }
];

const formValues = computed(() => ({
  isReceivedFavoriteOfficeOrder: isReceivedFavoriteOfficeOrder.value,
  isReceivedLimitedOrder: isReceivedLimitedOrder.value,
  isReceivedIndividualOrder: isReceivedIndividualOrder.value,
  isReceivedNearbyOfficeOrder: isReceivedNearbyOfficeOrder.value,
  isReceivedCancelRecoveryOrderPushForWorker:
    isReceivedCancelRecoveryOrderPushForWorker.value
}));

async function onSubmit() {
  loader.show();
  try {
    await accountService.patchUser({
      isReceivedFavoriteOfficeOrder: isReceivedFavoriteOfficeOrder.value,
      isReceivedLimitedOrder: isReceivedLimitedOrder.value,
      isReceivedIndividualOrder: isReceivedIndividualOrder.value,
      isReceivedNearbyOfficeOrder: isReceivedNearbyOfficeOrder.value,
      isReceivedCancelRecoveryOrderPushForWorker:
        isReceivedCancelRecoveryOrderPushForWorker.value
    });
    await modal.msgBoxOk("プッシュ通知受信設定を変更しました", {
      okVariant: "success",
      centered: true
    });
    await customRouter.pushIgnoreError({ name: "Mypage" });
  } catch (err) {
    errorModal.showErrorModal(err as Error);
  } finally {
    loader.hide();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_BForm = _resolveComponent("BForm")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header, null, {
      left: _withCtx(() => [
        _createVNode(FeatherIcon, {
          icon: "chevron-left",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      プッシュ通知受信設定\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createVNode(_component_CustomValidationObserver, {
      tag: "div",
      class: "my-4 mx-3",
      initialValues: formValues.value
    }, {
      default: _withCtx(({ handleSubmit }) => [
        _createVNode(InfoCard, { "body-class": "p-2" }, {
          default: _withCtx(() => [
            _hoisted_1
          ], undefined, true),
          _: 1
        }),
        _createTextVNode(),
        _createVNode(_component_BForm, null, {
          default: _withCtx(() => [
            _createVNode(_component_ValidationProvider, {
              name: "指名オファーのお仕事",
              rules: "required_allow_false",
              vid: "isReceivedIndividualOrder",
              class: "mt-3"
            }, {
              default: _withCtx((validationState) => [
                _createVNode(FormRadioGroup, {
                  label: "指名オファー",
                  name: "指名オファー",
                  modelValue: isReceivedIndividualOrder.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isReceivedIndividualOrder).value = $event)),
                  options: options,
                  "validation-state": validationState
                }, null, 8, ["modelValue", "validation-state"])
              ]),
              _: 1
            }),
            _createTextVNode(),
            _createVNode(_component_ValidationProvider, {
              name: "限定公開のお仕事",
              rules: "required_allow_false",
              vid: "isReceivedLimitedOrder",
              class: "mt-3"
            }, {
              default: _withCtx((validationState) => [
                _createVNode(FormRadioGroup, {
                  label: "限定公開のお仕事",
                  name: "限定公開のお仕事",
                  modelValue: isReceivedLimitedOrder.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isReceivedLimitedOrder).value = $event)),
                  options: options,
                  "validation-state": validationState
                }, null, 8, ["modelValue", "validation-state"])
              ]),
              _: 1
            }),
            _createTextVNode(),
            _createVNode(_component_ValidationProvider, {
              name: "お気に入り事業所のお仕事",
              rules: "required_allow_false",
              vid: "isReceivedFavoriteOfficeOrder",
              class: "mt-3"
            }, {
              default: _withCtx((validationState) => [
                _createVNode(FormRadioGroup, {
                  label: "お気に入り事業所のお仕事",
                  name: "お気に入り事業所のお仕事",
                  modelValue: isReceivedFavoriteOfficeOrder.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isReceivedFavoriteOfficeOrder).value = $event)),
                  options: options,
                  "validation-state": validationState
                }, null, 8, ["modelValue", "validation-state"])
              ]),
              _: 1
            }),
            _createTextVNode(),
            _createVNode(_component_ValidationProvider, {
              name: "近くの事業所のお仕事",
              rules: "required_allow_false",
              vid: "isReceivedNearbyOfficeOrder",
              class: "mt-3"
            }, {
              default: _withCtx((validationState) => [
                _createVNode(FormRadioGroup, {
                  label: "近くの事業所のお仕事",
                  name: "近くの事業所のお仕事",
                  modelValue: isReceivedNearbyOfficeOrder.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isReceivedNearbyOfficeOrder).value = $event)),
                  options: options,
                  "validation-state": validationState
                }, null, 8, ["modelValue", "validation-state"])
              ]),
              _: 1
            }),
            _createTextVNode(),
            _createVNode(_component_ValidationProvider, {
              name: "キャンセル発生時の緊急募集のお仕事",
              rules: "required_allow_false",
              vid: "isReceivedCancelRecoveryOrderPushForWorker",
              class: "mt-3"
            }, {
              default: _withCtx((validationState) => [
                _createVNode(FormRadioGroup, {
                  label: "キャンセル発生時の緊急募集のお仕事",
                  name: "cancel-recovery-order",
                  modelValue: isReceivedCancelRecoveryOrderPushForWorker.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((isReceivedCancelRecoveryOrderPushForWorker).value = $event)),
                  options: options,
                  "validation-state": validationState
                }, null, 8, ["modelValue", "validation-state"])
              ]),
              _: 1
            }),
            _createTextVNode(),
            _createVNode(AppButton, {
              block: "",
              class: "mt-4",
              onClick: ($event: any) => (handleSubmit(onSubmit))
            }, {
              default: _withCtx(() => [
                _createTextVNode("\n          更新する\n        ")
              ], undefined, true),
              _: 2
            }, 1032, ["onClick"])
          ], undefined, true),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["initialValues"])
  ]))
}
}

})